import React, { useState, useEffect } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import logger from "../logger";
import { listFAQ } from "../graphql/queries";
import { createFAQ, updateFAQ } from "../graphql/mutations";
import FaqCard from "./FaqCard";

const useStyles = makeStyles(theme => ({
  loading: {
    margin: theme.spacing(1)
  }
}));

const FaqList = ({ storeID, productID, mobile }) => {
  const classes = useStyles();

  const [fetchingFAQ, setFetchingFAQ] = useState(true);
  const [faqs, setFAQs] = useState([]);

  useEffect(() => {
    const fetchFAQ = async () => {
      setFetchingFAQ(true);

      try {
        const vars = {
          storeID,
          productID: {
            eq: productID
          }
        };

        const result = await API.graphql(graphqlOperation(listFAQ, vars));

        if (result.data.faqsByStoreProduct && result.data.faqsByStoreProduct.items) {
          setFAQs(result.data.faqsByStoreProduct.items);
        }
      } catch (err) {
        logger("FaqList.fetch.error", err);
      } finally {
        setFetchingFAQ(false);
      }
    };

    if (storeID && productID) {
      fetchFAQ();
    }
  }, [storeID, productID]);

  const agregar = async faq => {
    try {
      const vars = {
        input: {
          ...faq,
          storeID,
          productID
        }
      };
      const result = await API.graphql(graphqlOperation(createFAQ, vars));

      if (result.data.createFAQ) {
        setFAQs(s => [...s, result.data.createFAQ]);
      }
    } catch (err) {
      logger("FaqList.agregar.error", err);
    }
  };

  const actualizar = async faq => {
    try {
      const vars = { input: faq };
      const result = await API.graphql(graphqlOperation(updateFAQ, vars));

      if (result.data.updateFAQ) {
        const updated = [];

        for (let i = 0; i < faqs.length; i++) {
          if (faqs[i].id === faq.id) {
            updated.push(result.data.updateFAQ);
          } else {
            updated.push(faqs[i]);
          }
        }

        setFAQs(updated);
      }
    } catch (err) {
      logger("FaqList.actualizar.error", err);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FaqCard mobile={mobile} onSave={agregar} />
      </Grid>

      {fetchingFAQ ? (
        <Grid item xs={12} container justify="center">
          <Grid item>
            <CircularProgress className={classes.loading} size="2.5rem" />
          </Grid>
        </Grid>
      ) : (
        faqs.map((faq, index) => (
          <Grid key={`faq-${index}`} item xs={12}>
            <FaqCard mobile={mobile} faq={faq} onSave={actualizar} />
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default FaqList;
